import cx from 'classnames';
import type * as React from 'react';
import { FormLabelHelper } from './form.label-helper';
import type { FormLabelBase } from './form.types';
import { Text } from '@dx-ui/global-ui-prism';

type FormLegend = FormLabelBase<HTMLLegendElement>;

const FormLegend: React.FC<React.PropsWithChildren<FormLegend>> = ({
  label,
  required,
  optional,
  hasError,
  className,
  ...rest
}) => {
  return (
    <legend className={cx('label', className)} {...rest}>
      <Text
        as="span"
        className={cx('font-bold', {
          'text-surface-error': hasError,
        })}
      >
        {label}
        <FormLabelHelper required={required} optional={optional} hasError={hasError} />
      </Text>
    </legend>
  );
};

export { FormLegend };
export default FormLegend;
